import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    copyToOperations: translate({ id: 'orders.copyToOperations' }),
    duplicate: translate({ id: 'global.duplicate' }),
    export: translate({ id: 'global.export' }),
    delete: translate({ id: 'global.delete' }),
    deleteDisabledArchived: translate({
      id: 'orders.viewDetails.delete.disabled.tooltip',
    }),
    duplicateDisabledArchived: translate({
      id: 'orders.viewDetails.duplicate.disabled.tooltip',
    }),
  }))

  return api
}
